import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { observer } from 'mobx-react';
import ReactCodeInput from 'react-code-input';

import { useStores } from '../../hooks/use-stores';
import { RegisterLoc } from '../../loc/register';
import { loc } from '../../lib/loc';

import ErrorMessage from '../../interface/ErrorMessage';

const CompleteRegister = observer(() => {
    const { RegisterStore: store } = useStores();
    const { confirmed, errorMessage, confirm, revokeConfirmation } = store || {};

    const onChange = code => {
        if (code.length === 6) {
            confirm(code);
        }
    };

    useEffect(() => {
        return () => revokeConfirmation();
    }, [revokeConfirmation]);

    return (
        <div
            style={{
                display: 'flex',
                height: '100%',
            }}
        >
            {confirmed && (
                <Redirect
                    to={{
                        pathname: '/',
                        state: {
                            showModal: true,
                        },
                    }}
                />
            )}
            <div style={{ maxWidth: '480px', margin: '30px auto', textAlign: 'center' }}>
                <img src={`${process.env.REACT_APP_PATH}public/img/ok-icon.svg`} style={{ marginBottom: '10px' }} alt={''} />
                <h3>{loc(RegisterLoc.registerSuccess.title)}</h3>
                <p style={{ marginTop: '15px', marginBottom: '15px' }}>{loc(RegisterLoc.registerSuccess.text)}</p>
                {errorMessage && <ErrorMessage message={errorMessage || ''} />}
                <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <ReactCodeInput type="number" fields={6} autoFocus={true} onChange={onChange} />
                </div>
            </div>
        </div>
    );
});

export default CompleteRegister;
